import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { logPageView } from '../../models/Analytics';
import { MainContainer } from '../MainContainer';
import './styles.less';

interface IProps extends RouteComponentProps<any> {
	className?: string;
}

interface IState {
	errorMessage?: string;
	requestInviteEmail?: string;
}

export class Features extends React.Component<IProps, IState> {
	public state: IState = {
		errorMessage: null,
		requestInviteEmail: '',
	};

	public componentDidMount() {
		window.scrollTo(0, 0);
		document.title = 'Levitate - Features';
		logPageView('Features');
	}

	public render() {
		return (
			<MainContainer activeSection='features'>
				<div className='features-heroContainer' />
				<div className='features-grid-outerContainer'>
					<div className='features-grid-container'>
						<div className='features-grid-header'>
							<div>Feature List</div>
						</div>
						<div className='features-grid-body-container'>
							<div className='features-grid-body-sectionHeader'>
							Importing and Exporting Contacts
							</div>
							<div className='features-grid-body-item'>
							Import contacts from email address book, calendar, and sent messages.
							</div>
							<div className='features-grid-body-item'>
							Import contacts from any Excel spreadsheet or CSV. (Business Plan only)
							</div>
							<div className='features-grid-body-item'>
							Import contacts from popular CRM systems like Salesforce, Hubspot, and Dynamics. (Business Plan only)
							</div>
							<div className='features-grid-body-item'>
							Import contacts from AMS systems like AMS 360, QQCatalyst, Cigita, TAM, Epic, Hawksoft, EZLynx, and Partner XE. (Business Plan only)
							</div>
							<div className='features-grid-body-item'>
							Any time contacts are imported, they are enhanced using publicly available information like profile pictures,
							social media links (Twitter, LinkedIn, Facebook), company information, web site, bio, and other details. (Business Plan only)
							</div>
							<div className='features-grid-body-item'>
							Search and filter contacts based on tags, then export them from Levitate to CSV.
							</div>

							<div className='features-grid-body-sectionHeader'>
							Email and Calendar Integration
							</div>
							<div className='features-grid-body-item'>
							Integration with Office 365, traditional Exchange Server, Gmail, Google Apps, Hotmail, Outlook.com, Live.com,
							or almost any IMAP email system (traditional Exchange and IMAP for Business Plan only)
							</div>
							<div className='features-grid-body-item'>
							Add-ins for Outlook and Gmail to make it easy to mark contacts for keep in touch, add tags and key facts, and record notes without ever leaving your email system
							</div>
							<div className='features-grid-body-item'>
							Track with Levitate button for Outlook see when recipients have viewed your messages or if they don't reply back to you
							</div>
							<div className='features-grid-body-item'>
							See recent meetings from your calendar and easily record notes for those meetings. The notes will automatically get associated with the meeting attendees.
							</div>

							<div className='features-grid-body-sectionHeader'>
							Mobile Apps
							</div>
							<div className='features-grid-body-item'>
							iPhone and Android mobile apps
							</div>
							<div className='features-grid-body-item'>
							Business card scanning - take a picture of any business card to automatically add it to Levitate. (Busines Plan only)
							</div>
							<div className='features-grid-body-item'>
							Search for people or companies to review notes and key facts on the go
							</div>
							<div className='features-grid-body-item'>
							Easily type or dictate notes about recent meetings and see upcoming meetings so you can review the background about people you're meeting with before you walk into the room
							</div>
							<div className='features-grid-body-item'>
							Mark people for keep in touch and record key facts while the information is still fresh
							</div>

							<div className='features-grid-body-sectionHeader'>
							Keep in Touch
							</div>
							<div className='features-grid-body-item'>
							Create custom tags contacts and companies.
							</div>
							<div className='features-grid-body-item'>
							Ability to mark contacts for keep in touch with a customizable interval.
							Levitate syncs with your email and calendar and will let you know about contacts you've marked for keep in touch that you haven't interacted with.
							</div>
							<div className='features-grid-body-item'>
							Set up tag notifications to get notified about groups that you have not been in touch with.
							</div>
							<div className='features-grid-body-item'>
							Receive weekly emails letting you know which contacts you need to reach out to, with the ability to kick off a message to those contacts with one click from your email.
							</div>

							<div className='features-grid-body-sectionHeader'>
							Messaging
							</div>
							<div className='features-grid-body-item'>
							Integration with your email system so any messages sent through Levitate show up in your sent messages folder and are sent from your email account, not ours.
							</div>
							<div className='features-grid-body-item'>
							Create multiple message templates to keep in touch more efficiently rather than having to start from scratch every time. Share templates with your co-workers.
							</div>
							<div className='features-grid-body-item'>
							Send email messages to an entire group with the ability to customize the message for individuals. Each recipient gets an individual email from your own account, not an impersonal email marketing system.
							</div>
							<div className='features-grid-body-item'>
							Set up "no reply" action items to be notified if a recipient doesn't get back to you.
							</div>
							<div className='features-grid-body-item'>
							Determine whether the recipient has viewed your email without having to send a Read Receipt.
							</div>

							<div className='features-grid-body-sectionHeader'>
							Reporting and Analytics
							</div>
							<div className='features-grid-body-item'>
							Monthly Owner's Report broken down by employee that provides analytics about how well you're doing keeping in touch with groups
							that are important for driving referral and word of mouth business (Business Plan only)
							</div>
							<div className='features-grid-body-item'>
							Robust custom reporting, so you can track stats about your emails, meetings, and action items by company or contact (Business Plan only)
							</div>
							<div className='features-grid-body-item'>
							Relationship Analytics allows you to visit the profile of any contact and immediately see statistics about number of emails sent and meetings
							across your company as well as a feed showing who within your company has met or emailed the contact and when (Business Plan only)
							</div>

							<div className='features-grid-body-sectionHeader'>
							Key Facts, Notes and Action Items
							</div>
							<div className='features-grid-body-item'>
							Record key facts in seconds, so you'll never forget hobbies, spouse names, kids' names, pets, and all of those other details that help deepen business relationships.
							</div>
							<div className='features-grid-body-item'>
							Set action items for tasks with a specific due date. Assign the to yourself or another team member and they will show up on your calendar the day they are due.
							</div>
							<div className='features-grid-body-item'>
							Easily record notes so they'll be available next time you meet with contacts or keep in touch.
							Mark them private or share them with colleagues so they can benefit from the information next time they are interacting with the contact or company.
							</div>

							<div className='features-grid-body-sectionHeader'>
							Support
							</div>
							<div className='features-grid-body-item'>
							Designated Account Manager to help onboard and train you and your team (Business Plan only)
							</div>
							<div className='features-grid-body-item'>
							US-based technical support (Business Plan only)
							</div>
							<div className='features-grid-body-item'>
							Quickstart help videos and PDFs to walk you through common tasks
							</div>
						</div>
					</div>
				</div>
			</MainContainer>
		);
	}
}
